import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
    noOutline: {
        '&:focus': {
            outline: 'none',
        },
    },
    link: {
        fontFamily: theme.typography.fontFamily,
        textDecoration: 'none',
    },
    'kind-dark-blue': {
        color: theme.palette.grey[700],
    },
    'kind-muted': {
        color: theme.palette.grey[50],
        fill: theme.palette.grey[50],
        stroke: theme.palette.grey[50],
    },
    'kind-mint-underline': {
        textDecoration: 'underline',
        color: theme.palette.secondary.main,
    },
    'kind-mint-uppercase': {
        textTransform: 'uppercase',
        color: theme.palette.secondary.main,
    },
    'kind-mint': {
        color: theme.palette.secondary.main,
    },
    'kind-underline': {
        textDecoration: 'underline',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    'kind-uppercase': {
        textTransform: 'uppercase',
    },
    'kind-underline-uppercase': {
        textDecoration: 'underline',
        textTransform: 'uppercase',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    'kind-hover-underline': {
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));
const Link = React.forwardRef(({ to, children, className, kind, disableOutline, ...rest }, ref) => {
    const { classes, cx } = useStyles();
    return (_jsx("a", { ref: ref, href: to, className: cx(className, classes.link, {
            [classes[`kind-${kind}`]]: Boolean(kind),
            [classes.noOutline]: disableOutline,
        }), ...rest, children: children }));
});
export { Link };
